// extracted by mini-css-extract-plugin
export default {"input":"styles__input___sQhk2","select":"styles__select___EDA0q styles__input___sQhk2"};